__turbopack_context__.v({
  "h2": "AbvbmG_h2",
  "p": "AbvbmG_p",
  "sectionPadding": "AbvbmG_sectionPadding",
});
